import {
  ExclamationTriangleIcon,
  ServerStackIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';
import React from 'react';

interface IconProps {
  className?: string;
}

export const AssetsIcon: React.FC<IconProps> = ({ className }) => (
  <ServerStackIcon className={className} />
);

export const RisksIcon: React.FC<IconProps> = ({ className }) => (
  <ExclamationTriangleIcon className={className} />
);

export const CapabilitiesIcon: React.FC<IconProps> = ({ className }) => (
  <ShieldCheckIcon className={className} />
);

export { AgentsIcon } from './Agents.icon';
export { AttackPathsIcon } from './AttackPaths.icon';
export { NoAiIcon } from './NoAi.icon';
export { NoAssetsFound } from './NoAssetsFound';
export { Seeds } from './Seeds';
export { Vulnerabilities } from './Vulnerabilities';
export { XCircleIcon } from './XCircle.icon';
